import {
  grades,
  statusTypes,
  terms,
  unitOptions,
  unitTypes,
  courseRequirements,
  ptCourseRequirements,
  combinedCourseOptions
} from '../config/constants';
import genericValidationMethods, { getValidationState } from './genericValidation';

export function EducationValidation() {
  this.rules = {
    colleges: {
      validationMethod: 'getCollegesValidationState',
      errorMsg: 'Incomplete Colleges',
      id: 'colleges'
    },
    requirements: {
      validationMethod: 'getRequirementsValidationState',
      errorMsg: 'Missing Required Courses',
      id: 'colleges'
    }
  };
  this.getCollegesValidationState = function(colleges) {
    // At least one college is present and no errors
    const badColleges = colleges.filter((college) => new CollegeValidation().getValidationStatus(college).section.status !== 'success');
    return (colleges.length > 0 && badColleges.length === 0) ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getRequirementsValidationState = function(colleges) {
    // Get all courses and make sure all requirements are met by those courses
    let courses = [];
    colleges.forEach(college => courses = [...courses, ...college.courses]);
    const unmetRequirements = Object.keys(courseRequirements).filter(requirement => {
      const course = courses.find(course => {
        return course.requirement === requirement && !course.repeat && course.grade !== "EW";
      });
      return !course;
    });
    return unmetRequirements.length === 0 ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getValidationStatus = getValidationState.bind(this);
}

export function EducationValidationPT() {
  this.rules = {
    colleges: {
      validationMethod: 'getCollegesValidationState',
      errorMsg: 'Incomplete Colleges',
      id: 'colleges'
    },
    requirements: {
      validationMethod: 'getRequirementsValidationState',
      errorMsg: 'Missing Required Courses',
      id: 'colleges'
    }
  };
  this.getCollegesValidationState = function(colleges) {
    // At least one college is present and no errors
    const badColleges = colleges.filter((college) => new CollegeValidation().getValidationStatus(college).section.status !== 'success');
    return (colleges.length > 0 && badColleges.length === 0) ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getRequirementsValidationState = function(colleges) {
    // Get all courses and make sure all requirements are met by those courses
    let courses = [];
    colleges.forEach(college => courses = [...courses, ...college.courses]);
    const unmetRequirements = Object.keys(ptCourseRequirements).filter(requirement => {
      const course = courses.find(course => {
        return (course.requirement === requirement || course.requirement.includes(requirement))&& !course.repeat;
      });
      return !course;
    });
    return unmetRequirements.length === 0 ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getValidationStatus = getValidationState.bind(this);
}

export function CollegeValidation() {
  this.rules = {
    name: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing College Name',
      id: 'name'
    },
    location: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing Location',
      id: 'location'
    },
    unitType: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Unit Type',
      id: 'unitType',
      options: Object.keys(unitTypes)
    },
    courses: {
      validationMethod: 'getCoursesValidationState',
      errorMsg: 'Incomplete Courses',
      id: 'courses'
    }
  };
  this.getCoursesValidationState = function(courses) {
    // At least 1 course and no errors. Update: Allow college to not have courses
    const problemCourses = courses.filter((course) => new CourseValidation().getValidationStatus(course).section.status !== statusTypes.SUCCESS);
    return (problemCourses.length === 0) ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getEnumValidationState = genericValidationMethods.getEnumValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export function CourseValidation() {
  this.rules = {
    name: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing Course Name',
      id: 'name'
    },
    term: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Term',
      id: 'term',
      options: Object.keys(terms)
    },
    year: {
      validationMethod: 'getYearValidationState',
      errorMsg: 'Invalid Year',
      id: 'year'
    },
    grade: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Grade',
      id: 'grade',
      options: grades
    },
    units: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Units',
      id: 'units',
      options: unitOptions
    },
    requirement: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Requirement',
      id: 'requirement',
      options: Object.keys(combinedCourseOptions)
    }
  };
  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getEnumValidationState = genericValidationMethods.getEnumValidationState;
  this.getYearValidationState = genericValidationMethods.getYearValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export default EducationValidation;